// App root — boot once, then mount the mode shell.
// Only Builder is enabled in MVP; Explorer + Founder render coming-soon stubs.

import { useEffect, useState } from 'react';
import { GameStoreProvider } from '@biz-kid/store';
import { bootApp, type BootResult } from './boot/createApp.js';
import { BuilderShell } from './routes/builder/BuilderShell.js';
import { ParentGate } from './routes/parent/ParentGate.js';
import { ModalQueueProvider } from './ui/modalQueue.js';
import { VoiceProvider } from './voice/VoiceContext.js';

export function App() {
  const [boot, setBoot] = useState<BootResult | null>(null);
  const [bootError, setBootError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    bootApp()
      .then((result) => {
        if (cancelled) {
          result.unsubscribePersist();
          return;
        }
        setBoot(result);
      })
      .catch((e: unknown) => {
        setBootError(String(e));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    return () => {
      boot?.unsubscribePersist();
    };
  }, [boot]);

  if (bootError) {
    return (
      <div className="min-h-dvh grid place-items-center p-6 text-center">
        <div className="font-display text-ink-1 max-w-md">
          <h1 className="text-2xl font-bold mb-2">Couldn't open Biz Kid</h1>
          <p className="text-ink-2">{bootError}</p>
        </div>
      </div>
    );
  }

  if (!boot) {
    return (
      <div className="min-h-dvh grid place-items-center">
        <div className="font-display text-ink-2">Waking up the dawn…</div>
      </div>
    );
  }

  return (
    <GameStoreProvider store={boot.store}>
      <ModalQueueProvider>
        <VoiceProvider>
          <div className="bk-app">
            <BuilderShell catchup={boot.catchup} />
            <ParentGate />
          </div>
        </VoiceProvider>
      </ModalQueueProvider>
    </GameStoreProvider>
  );
}
